/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { partitionsGet } from "../../funcs/partitionsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetPartitionPartitionsPartitionIdGetRequest$inboundSchema,
};

export const tool$partitionsGet: ToolDefinition<typeof args> = {
  name: "partitions-get",
  description: `Get Partition

Get a partition by its ID. Includes usage information such as the number of documents and pages hosted and processed. The partition's limits are also included.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await partitionsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
